import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postInvoiceInEaccounting = (
    token: string,
    backend: string,
    invoiceId: any,
    invoiceRows: any,
    blob?: any
) => {

    var requestData = new FormData();
    requestData.append('invoiceId', invoiceId);
    requestData.append('invoiceRows', JSON.stringify(invoiceRows));

    if(blob) {
        requestData.append('attachment', blob);
    }
    
    return fetch(
        `${getApiUrl(backend)}create_invoice_in_eaccounting`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: requestData
        }
    );
};

export default postInvoiceInEaccounting;
